<template>
  <Layout>
    <Header style="background-color: #1c1c23">
      <Row>
        <Col span="2">
          <div style="margin-top: 4px"><img src="@/assets/shiyi3.png" width="120"></div>
        </Col>
        <Col span="1" offset="17">
          <router-link to="mainPage"><span style="color: #ffffff">首页</span></router-link>
        </Col>
        <Col span="1">
          <router-link to="imagePage"><span style="color: #ffffff">图片</span></router-link>
        </Col>
        <Col span="1">
          <router-link to="dynamicWallpaperPage"><span style="color: #ffffff">视频</span></router-link>
        </Col>
        <Col span="1">
          <Dropdown>
            <a href="javascript:void(0)" style="color: white">
              发现
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <router-link to="discoverImgPage">
                <DropdownItem>
                  <span style="color: black">静态壁纸</span>
                </DropdownItem>
              </router-link>
              <router-link to="discoverMp4Page">
                <DropdownItem>
                  <span style="color: black">动态壁纸</span>
                </DropdownItem>
              </router-link>
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col span="1">
          <router-link to="albumPage"><span style="color: #ffffff">专辑</span></router-link>
        </Col>
      </Row>
    </Header>
    <Content>
      <router-view/>
    </Content>
    <Footer>
      <div style="margin-left: 100px">
        <a href="https://beian.miit.gov.cn">蜀ICP备2024101586号</a>
        <span>|</span>
        <router-link to="copyright"><span>版权声明</span></router-link>
        <span>|</span>
        <img src="@/assets/qq.jpg" width="15">
        <a href="tencent://message/?uin=2658248317&Site=Sambow&Menu=yes">QQ在线联系</a>
        <p></p>
        <span>
          © 2009-{{new Date().getFullYear()}} SHIYIPIC Ltd. 视一公司 版权所有
        </span>
      </div>
    </Footer>
  </Layout>
</template>

<script>
  export default {
    name: 'LayoutMain'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LayoutMain.vue